import { render, staticRenderFns } from "./stats-dashboard.vue?vue&type=template&id=407337c6&scoped=true&"
import script from "./stats-dashboard.vue?vue&type=script&lang=js&"
export * from "./stats-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./stats-dashboard.vue?vue&type=style&index=0&id=407337c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407337c6",
  null
  
)

export default component.exports